export default __webpack_public_path__ + "static/media/DiningRoom400.c6a3ddfd.jpg";